// =============================================================================
// DISA AKTARMA ORTAK YARDIMCILARI
// =============================================================================
// Butun calisma ciktilari (T-sablon, profil defteri, morfoloji, izah cetveli,
// lab verisi) kayitlari ve dosya adlarini BURADAN alir.
// =============================================================================

// "P12" -> 12, "S105" -> 105. Numarasi olmayan en sona gider.
export const numaraDegeri = (no) => {
  const m = String(no ?? "").match(/\d+/);
  return m ? parseInt(m[0], 10) : Number.MAX_SAFE_INTEGER;
};

// Kayitlari KENDI numaralarina gore kucukten buyuge dizer.
// Yeniden numaralandirma YAPMAZ: P12 yine P12, S7 yine S7 olarak kalir.
// Metin siralamasinda P100, P12'den once gelir; bu yuzden rakam degeri
// karsilastirilir, esitlikte metne bakilir (P12 / P12A).
export const numarayaGoreSirala = (liste, alan) =>
  [...(liste || [])].sort(
    (a, b) =>
      numaraDegeri(a?.[alan]) - numaraDegeri(b?.[alan]) ||
      String(a?.[alan] ?? "").localeCompare(String(b?.[alan] ?? ""), "tr"),
  );

// Dosya adi: "<Calisma adi>_<Belge adi>.<uzanti>"
// Turkce harfler KORUNUR ("Şanlıurfalot_15_Sonda_İzah_Cetveli.pdf").
// Eskiden [^a-z0-9] -> "_" yapildigi icin "_anl_urfalot_15" gibi bozuluyordu.
export const dosyaAdi = (calismaAdi, belgeAdi, uzanti) => {
  const temizle = (s) =>
    String(s ?? "")
      .normalize("NFC")
      .replace(/[\\/:*?"<>| -]+/g, " ")
      .trim()
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_")
      .replace(/^[_.]+|[_.]+$/g, "");

  const parcalar = [temizle(calismaAdi) || "Calisma", temizle(belgeAdi)]
    .filter(Boolean)
    .join("_");
  return `${parcalar}.${uzanti}`;
};
